import Card from './ui/Card';
import Icon from './ui/Icon';
import Reveal from './ui/Reveal';
import { inHouse } from '../data/content';

export default function InHouseTraining() {
  return (
    <section className="alt" id="in-house">
      <div className="wrap center">
        <Reveal as="span" className="eyebrow">
          {inHouse.eyebrow}
        </Reveal>

        <Reveal as="h2" className="h-sec inhouse-title" delay={1}>
          {inHouse.title}
          <br />
          <span className="dim">{inHouse.titleAlt}</span>
        </Reveal>

        <div className="inhouse-grid mt-l">
          {inHouse.cards.map((card, i) => (
            <Reveal key={card.title} delay={i}>
              <Card className="inhouse-card">
                <div className="ic-tile ic-center">
                  <Icon name={card.icon} />
                </div>
                <h3>{card.title}</h3>
                <p>{card.body}</p>
              </Card>
            </Reveal>
          ))}
        </div>

        <Reveal as="p" className="inhouse-note" delay={1}>
          {inHouse.note}
        </Reveal>

        <Reveal delay={2}>
          {/* iClosed's loader binds to these two attributes and opens its own
              popup modal — no click handler of ours is involved. */}
          <button
            type="button"
            className="btn btn-primary inhouse-btn"
            data-iclosed-link={inHouse.ctaLink}
            data-embed-type="popup"
          >
            {inHouse.cta}
          </button>
        </Reveal>
      </div>
    </section>
  );
}
